
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCompareGoogle as ObiCompareGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-compare-google.js';
 
 
 

 
 export const ObiCompareGoogle = createComponent({
   react: React,
   tagName: 'obi-compare-google',
   elementClass: ObiCompareGoogleElement,
   events: {
     
   }
  });
 
 